export const PRO_QUIZ_FORM = 'PRO_QUIZ_FORM';
export const PRO_QUIZ_MODAL = 'PRO_QUIZ_MODAL';
export const RETAIL_QUIZ_FORM = 'RETAIL_QUIZ_FORM';
export const RETAIL_QUIZ_MODAL = 'RETAIL_QUIZ_MODAL';
